<template>
  <div class="seccion_cardsOpciones">
    <div class="row">
      <div class="card-zone col-xs-12 col-sm-12 col-md-6" v-for="(contenido, index) in cards" :key="index">
        <div class="card mb-3 p-1">
          <div class="row no-gutters">
            <div class="col-md-4 p-2 text-center justify-content-center">
              <i v-if="contenido.esIcono" :class="contenido.recurso" class="icono_card"></i>
              <img v-else :src="urlServe + contenido.recurso" alt="card image" class="img-fluid icono_card"/>
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title titulo_subsec mb-0">{{ contenido.titulo }}</h5>
                <p style="font-size:.8rem; color: #b9b9b9;" class="mb-0">{{ contenido.descripcion }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cards: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>
<style scoped>
</style>